// Sentry initialization for the React frontend.
// Env-gated: when REACT_APP_SENTRY_DSN is missing, init() becomes a no-op.
//
// Capture coverage:
//   - Unhandled exceptions
//   - Unhandled promise rejections
//   - React Error Boundary (via Sentry.ErrorBoundary wrapper exported below)
//
// PII: explicitly disabled (sendDefaultPii=false).

import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || "development";
const release = process.env.REACT_APP_SENTRY_RELEASE || undefined;

let initialized = false;

if (dsn) {
  try {
    Sentry.init({
      dsn,
      environment,
      release,
      integrations: [Sentry.browserTracingIntegration()],
      // Lower sample rate; user can tune via REACT_APP_SENTRY_TRACES_SAMPLE_RATE if desired.
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
      sendDefaultPii: false,
      // Drop common PII-bearing headers and query strings before send.
      beforeSend(event) {
        try {
          const req = event.request || {};
          const hdrs = req.headers || {};
          ["Authorization", "Cookie", "Set-Cookie", "X-Api-Key"].forEach((h) => {
            if (h in hdrs) hdrs[h] = "<redacted>";
          });
          if ("query_string" in req) req.query_string = "<redacted>";
        } catch (_) {}
        return event;
      },
    });
    initialized = true;
    // eslint-disable-next-line no-console
    console.info("[Sentry] initialized env=" + environment);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[Sentry] init failed:", e);
  }
}

export const SentryReact = Sentry;
export const sentryInitialized = () => initialized;

// ErrorBoundary wrapper: callers can do <SentryErrorBoundary fallback={...}>...</SentryErrorBoundary>
export const SentryErrorBoundary = Sentry.ErrorBoundary;
